import PropTypes from 'prop-types';
import { useState } from 'react';
import { formatPhoneNumber, isValidationBasedOnType } from '../../utils/common';
import { VALID_PHONE_NUMBER } from '../../utils/constant';

const PhoneNumberForm = ({ element, handleChange }) => {
  const [showError, setShowError] = useState(false);
 
  const handleClick = (event) => {
    const { value } = event.target;
    let tmpValue = formatPhoneNumber(value);
    if (tmpValue.length > 14) {
      tmpValue = formatPhoneNumber(value.substr(value.length - 10));
    }
    const phoneNumber = formatPhoneNumber(tmpValue);
    const formatePhone = phoneNumber.replace(/[()-\s]/g, '');
    
    const question = { ...element, userInput: formatePhone, eligibleErr: true };
    if (question.isEligibal) {
      const eligVal = question.eligibleValues.split(',');
      if (eligVal?.includes(question.userInput)) {
        question.eligibleErr = false;
      }
    }
    
    if (isValidationBasedOnType(question?.userInput, 'phone')) {
      setShowError('');
      question.validationError = false;
    } else {
      setShowError(VALID_PHONE_NUMBER);
      question.validationError = true;
    }
    handleChange(event, question);
  };
  const changePhoneFormat =(phone) => {
    if(phone) {
      if(phone.length > 10) {
        return element?.userInput.substr(phone.length-10);
      } 
    }
    return phone;
  };
  return (
    <div className="d-flex">
      <div className="w-100">
        <input
          type="text"
          name={element?.question}
          value={formatPhoneNumber(changePhoneFormat(element?.userInput) || '')}
          maxLength={14}
          className="form-control fs-13 answer inputText"
          placeholder={element?.placeholder}
          onChange={handleClick}
        />
        <span className="text-danger fs-12">{showError !== '' && showError}</span>
      </div>
    </div>
  );
};

PhoneNumberForm.propTypes = {
  element: PropTypes.object,
  handleChange: PropTypes.func.isRequired,
};
export default PhoneNumberForm;
